import * as React from 'react';
import TopBar from 'components/organisms/top-bar';
import { Container, SxProps } from '@mui/material';
import { Footer, StripeConnectWarning } from 'components/organisms';
import { Loader } from 'components/atoms';
import { useLocation } from 'react-router-dom';
import CoreErrorAlert from 'components/organisms/core-error-alert';
import { useDispatch } from 'react-redux';
import { DisableOverlay } from 'base/common';
import { CoreSliceActions } from 'base/core/slice';

export interface Props {
  children: React.ReactNode;
  loading?: boolean;
  sx?: SxProps;
}
const ExpertHubLayout = ({ children, loading, sx }: Props) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const notificationIntervalRef = React.useRef<NodeJS.Timer | null>(null);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  React.useEffect(() => {
    if (notificationIntervalRef.current) {
      clearInterval(notificationIntervalRef.current);
      notificationIntervalRef.current = null;
    }

    notificationIntervalRef.current = setInterval(() => {
      dispatch(CoreSliceActions.getNotifications());
    }, 1000 * 10);

    return () => {
      if (notificationIntervalRef.current) {
        clearInterval(notificationIntervalRef.current);
        notificationIntervalRef.current = null;
      }
    };
  }, [dispatch]);

  return (
    <Loader loading={loading ?? false}>
      <TopBar />
      <StripeConnectWarning />
      <Container
        fixed
        sx={[
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        className="layout-container position-relative"
      >
        <CoreErrorAlert />
        {children}
        <DisableOverlay />
      </Container>
      <Footer />
    </Loader>
  );
};

ExpertHubLayout.defaultProps = {
  loading: false,
  sx: {
    py: {
      xs: '20px', sm: '35px', md: '35px', lg: '50px',
    },
  },
};

export default ExpertHubLayout;
